import type { PaymentCategory } from '../../types/financialReport';

const categoryConfig: Record<PaymentCategory, { label: string; classes: string }> = {
  paid: { label: 'Paid', classes: 'bg-green-100 text-green-800' },
  partial: { label: 'Partial', classes: 'bg-amber-100 text-amber-800' },
  issued: { label: 'Issued', classes: 'bg-blue-100 text-blue-800' },
  overdue: { label: 'Overdue', classes: 'bg-red-100 text-red-800' },
  notissued: { label: 'Not Issued', classes: 'bg-gray-100 text-gray-700' },
  cancelled: { label: 'Cancelled', classes: 'bg-gray-100 text-gray-500 line-through' },
  draft: { label: 'Draft', classes: 'bg-gray-100 text-gray-700' },
  none: { label: 'N/A', classes: 'bg-gray-50 text-gray-400' },
};

interface PaymentStatusBadgeProps {
  category: PaymentCategory;
  rawStatus?: string;
  daysOverdue?: number;
}

export function PaymentStatusBadge({ category, rawStatus, daysOverdue }: PaymentStatusBadgeProps) {
  const config = categoryConfig[category] || categoryConfig.none;
  const label =
    category === 'overdue' && daysOverdue && daysOverdue > 0
      ? `Overdue · ${daysOverdue}d`
      : config.label;

  return (
    <span
      className={`cm-chip ${config.classes}`}
      title={rawStatus || label}
    >
      {label}
    </span>
  );
}
